import { IButtonTile, ICategoryTile, IPromotionTile } from '@features/cms/typescript';
import CategoryTile from '@features/cms/components/categories/CategoryTilesBlock/components/CategoryTile/CategoryTile';
import { isButtonTile, isCategoryTile, isPromotionTile } from '@features/cms/components/categories/CategoryTilesBlock/helpers/common';
import { TServiceMap } from '@features/categories';
import PromotionTile from '@features/cms/components/categories/CategoryTilesBlock/components/PromotionTile/PromotionTile';
import ButtonTile from '@features/cms/components/categories/CategoryTilesBlock/components/ButtonTile/ButtonTile';
type PropsType = {
  tile: ICategoryTile | IPromotionTile | IButtonTile;
  serviceMap: TServiceMap;
};
const SingleTile = ({
  tile,
  serviceMap
}: PropsType) => {
  if (isCategoryTile(tile)) {
    return <CategoryTile tile={tile} serviceMap={serviceMap} />;
  }
  if (isPromotionTile(tile)) {
    return <PromotionTile tile={tile} />;
  }
  if (isButtonTile(tile)) {
    return <ButtonTile tile={tile} />;
  }
  return null;
};
export default SingleTile;